import { Link, Outlet, useNavigate } from 'react-router-dom'
import { Heart, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'

const APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.0.1'

export function Layout() {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/memories" className="flex items-center gap-2 text-xl font-bold">
            <Heart className="h-6 w-6 text-primary" />
            <span>Kairos Anamnisi</span>
          </Link>
          <nav className="flex items-center gap-4">
            <Link to="/memories">
              <Button variant="ghost">My Memories</Button>
            </Link>
            <Link to="/memories/new">
              <Button>New Memory</Button>
            </Link>
            <Button variant="ghost" size="icon" onClick={handleLogout} title="Logout">
              <LogOut className="h-4 w-4" />
            </Button>
          </nav>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
      <footer className="border-t py-4 text-center text-sm text-muted-foreground">
        <p>Kairos Anamnisi v{APP_VERSION}</p>
      </footer>
    </div>
  )
}